/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
import React, { useState, useEffect } from "react";
import FieldDetailsModal from "./FieldDetails";
import ManageFarmBusinessModal from "./ManageFarmBusinessModal";
import {
  ADDED,
  SELECTED,
  SHAREDFIELD,
  LOGERROR,
  DANGER,
  SHARED_FIELDS,
  INFO,
  FIELDS,
  CROPS,
  EMPTY,
  FARM_BUSINESS_SELECT_STYLES,
} from "../../configurations/Constants";
import { Accordion, Card, Form } from "react-bootstrap";
import Select from "react-select";
import GoogleMapHelper from "../../helpers/GoogleMapHelper";
import SessionHelper from "../../helpers/SessionHelper";
import UserService from "../../api-service/UserService";
import ShareFieldPopUp from "../fieldDetails/FieldSharePopUp";
import DeletePopUp from "../wdpMap/DeleteShareFieldPopUp";
import ShareFieldService from "../../api-service/ShareFieldService";
import FluentdHelper from "../../helpers/FluentdHelper";
import Alert from "../common/Alert";
import _ from "lodash";
import { useSelector } from "react-redux";
import {
  DELETE_OR_REJECT_ACCESS_TO_SHARE_FIELD,
  SHARED_FIELD_REJECTED_SUCCESSFULLY,
  SHARED_FIELD_DELETED_SUCCESSFULLY,
  ERROR_FETCHING_FIELD_DETAILS,
  ERROR_WHILE_UPDATING_FIELD,
  MANAGE_FARM_BUSINESS,
  NO_FIELDS_FOR_SELECTED_FILTER,
  SELECT_BUSINESS_AND_FARM_TO_VIEW_FIELDS,
} from "../../configurations/MessageConstants";
import LoadingOverlay from "../common/LoadingOverlay";
import { StatusCodes } from "../../configurations/status-codes";

function WDPPanel({
  userRegisteredFields: userRegisteredFieldsProp,
  userClaimedFields: userClaimedFieldsProp,
  userSharedField: userSharedFieldProp,
  yearAcresDetails: yearAcresDetailsProp,
  showFieldOnMAP,
  field_edit,
  filterFieldsOnMap,
  field_check,
  fieldClicked,
  selectedField: selectedFieldProp,
  expand,
  removeWells: removeWellsProp,
  expandAll: expandAllProp,
  collapseAll: collapseAllProp,
  showWdpPanel,
  setShowWdpPanel,
  panelRef,
}) {
  const AllPolygons = useSelector((state) => state.field.allPolygons);
  const UserCropDetails = useSelector((state) => state.field.userCropDetails);
  const loggedInUser = useSelector((state) => state.user.loggedInUser);
  const FarmsValue = useSelector((state) => state.field.farms);
  const BusinessValue = useSelector((state) => state.field.business);

  const [userRegisteredFields, setUserRegisteredFields] = useState({});
  const [userClaimedFields, setUserClaimedFields] = useState({});
  const [userSharedFields, setUserSharedFields] = useState({});
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [irrig_unit_Id, setIrrig_unit_Id] = useState(EMPTY);
  const [header, setHeader] = useState(EMPTY);
  const [fieldId, setFieldId] = useState(EMPTY);
  const [showFieldPopup, setShowFieldPopup] = useState(false);
  const [fieldCrops, setFieldCrops] = useState([]);
  const [fieldAcres, setFieldAcres] = useState(EMPTY);
  const [selectedField, setSelectedField] = useState(EMPTY);
  const [fieldDetails, setFieldDetails] = useState({});
  const [fieldNames, setFieldNames] = useState([]);
  const [displayAllField, setDisplayAllField] = useState(true);
  const [sharedField, setSharedField] = useState(false);
  const [shareFieldDetails, setShareFieldDetails] = useState({});
  const [shareFieldPopUp, setShareFieldPopUp] = useState(false);
  const [selectedFieldsOnPanel, setSelectedFieldsOnPanel] = useState([]);
  const [selectedIrrigUnitIds, setSelectedIrrigUnitIds] = useState([]);
  const [shareFieldId, setShareFieldId] = useState(EMPTY);
  const [alertMessage, setAlertMessage] = useState(EMPTY);
  const [variant, setVariant] = useState(EMPTY);
  const [submitError, setSubmitError] = useState(false);
  const [overlayLoading, setOverlayLoading] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [defaultModalActiveKey, setDefaultModalActiveKey] = useState(EMPTY);
  const [showManageFarmBusinessModal, setShowManageFarmBusinessModal] = useState(false);
  const [selectedBusinesses, setSelectedBusinesses] = useState([]);
  const [selectedFarms, setSelectedFarms] = useState([]);
  const [businessOptions, setBusinessOptions] = useState([]);
  const [farmOptions, setFarmOptions] = useState([]);

  useEffect(() => {
    setUserRegisteredFields(userRegisteredFieldsProp);
    setUserClaimedFields(userClaimedFieldsProp);
    setUserSharedFields(userSharedFieldProp);
  }, []);

  useEffect(() => {
    loadBusinessAndFarms();
  }, [BusinessValue, FarmsValue]);

  useEffect(() => {
    if (businessOptions.length > 0 && displayAllField) {
      setSelectedBusinesses(businessOptions);
      setSelectedFarms(farmOptions);
    }
  }, [businessOptions, farmOptions, displayAllField]);

  const handdlePanelButtonClick = async (
    sortedUsersField,
    fieldId,
    cropDetails,
    acres,
    irrig_unit_Id,
    selectedField,
    fieldDetails,
    fieldNames,
    sharedField,
    shareFieldDetails,
    defaultModalActiveKey
  ) => {
    await SessionHelper.handleRefreshToken();

    const coordinates = fieldDetails;
    const geomObject = getGeometry(coordinates);
    if (geomObject) {
      coordinates.geometry = geomObject.geometry;
    }
    const paths = GoogleMapHelper.getCoordinates(coordinates);
    const coords = GoogleMapHelper.getPolygonCenter(coordinates);
    coords.lng = coords.lng + 0.023;
    const fillColor1 = sharedField ? SHAREDFIELD : ADDED;
    const fillColor2 = SELECTED;
    showFieldOnMAP(coords, paths, irrig_unit_Id, fillColor1, fillColor2);
    setDefaultModalActiveKey(defaultModalActiveKey);
    setFieldAcres(acres);
    setFieldCrops(cropDetails);
    setFieldId(fieldId);
    setIrrig_unit_Id(irrig_unit_Id);
    setSelectedField(selectedField);
    setFieldDetails(fieldDetails);
    setFieldNames(fieldNames);
    setSharedField(sharedField);
    setShareFieldDetails(shareFieldDetails);
    setShowFieldPopup(true);
    field_edit(sortedUsersField, true);
  };

  const syncLatestPanelFields = async () => {
    const userRegisteredFieldsValue = await getUserFieldDetails();
    const allShared = userRegisteredFieldsValue.data.shared;
    const nonRejectedSharedfields = allShared.filter((field) => {
      return field.rejected === false;
    });
    userRegisteredFieldsValue.data.shared = nonRejectedSharedfields;
    setUserRegisteredFields(userRegisteredFieldsValue);
    setUserSharedFields(userRegisteredFieldsValue.data.shared);
    return nonRejectedSharedfields;
  };

  const refreshPanel = async (value) => {
    const nonRejectedSharedfields = await syncLatestPanelFields();
    setShowFieldPopup(!value);
    filterFieldOnMapFromSelect(selectedBusinesses, selectedFarms, nonRejectedSharedfields);
    return nonRejectedSharedfields;
  };

  const closeModal = () => {
    setShowFieldPopup(false);
  };

  const getUserFieldDetails = async () => {
    try {
      if (!loggedInUser) return {};
      const payload = {
        user_email: loggedInUser,
        keys: [FIELDS, CROPS, SHARED_FIELDS],
      };
      const response = await UserService.getUserFieldDetails(payload);
      const userRegisteredFieldsValue = response.data;
      return response.status === StatusCodes.OK
        ? userRegisteredFieldsValue
        : {};
    } catch (error) {
      console.error(ERROR_FETCHING_FIELD_DETAILS, error);
    }
  };

  const getCurrentYearAcres = (irrig_unit_id) => {
    let currentyear = new Date().getFullYear();
    let isCurrentYearAcres = yearAcresDetailsProp[irrig_unit_id];
    if (isCurrentYearAcres) {
      let currentYearAcresData = _.find(isCurrentYearAcres.tp_year_wise_data, {
        crop_year: currentyear,
      });
      if (currentYearAcresData) {
        let currentYearAcres = currentYearAcresData.acres;
        return currentYearAcres;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const handleDisplayAllField = (event) => {
    const status = !displayAllField;
    setDisplayAllField(status);
    setSelectedFieldsOnPanel([]);
    setSelectedIrrigUnitIds([]);
    setSelectAll(false);

    if (status === true) {
      setSelectedBusinesses(businessOptions);
      setSelectedFarms(farmOptions);
      filterFieldOnMapFromSelect(businessOptions, farmOptions, false);
    } else {
      setSelectedBusinesses([]);
      setSelectedFarms([]);
      filterFieldOnMapFromSelect([], [], false);
    }
    removeWells();
  };

  const applyDisplayAllFieldsAndFilter = (sharedFields) => {
    const sharedFieldsToUse = sharedFields ?? userSharedFields;
    setDisplayAllField(true);
    setSelectedBusinesses(businessOptions);
    setSelectedFarms(farmOptions);
    setSelectedFieldsOnPanel([]);
    setSelectedIrrigUnitIds([]);
    setSelectAll(false);
    filterFieldOnMapFromSelect(
      businessOptions,
      farmOptions,
      sharedFieldsToUse
    );
    removeWells();
  };

  const onFarmBusinessUpdated = async () => {
    const nonRejectedSharedfields = await syncLatestPanelFields();
    applyDisplayAllFieldsAndFilter(nonRejectedSharedfields);
  }; 

  const handleBusinessChange = (selectedOptions) => {
    const selected = selectedOptions || [];
    setSelectedBusinesses(selected);
    
    const selectedBusinessNames = selected.map(business => business.value);
    
    const farmsForSelectedBusinesses = farmOptions.filter(farm =>
      selectedBusinessNames.includes(farm.businessName)
    );
    
    setSelectedFarms(farmsForSelectedBusinesses);
    setSelectedFieldsOnPanel([]);
    setSelectedIrrigUnitIds([]);
    setSelectAll(false);
    
    // Update displayAllField checkbox: checked only when ALL businesses AND farms are selected
    const allBusinessesSelected = selected.length === businessOptions.length && businessOptions.length > 0;
    const allFarmsSelected = farmsForSelectedBusinesses.length > 0;
    setDisplayAllField(allBusinessesSelected && allFarmsSelected);
    
    filterFieldOnMapFromSelect(selected, farmsForSelectedBusinesses, false);
    removeWells();
  };

  const handleFarmChange = (selectedOptions) => {
    const selected = selectedOptions || [];
    setSelectedFarms(selected);
    setSelectedFieldsOnPanel([]);
    setSelectedIrrigUnitIds([]);
    setSelectAll(false);
    
    // Update displayAllField checkbox: checked only when ALL businesses AND farms are selected
    const selectedBusinessNames = selectedBusinesses.map(business => business.value);
    const availableFarmsForSelectedBusinesses = farmOptions.filter(farm =>
      selectedBusinessNames.includes(farm.businessName)
    );
    const allBusinessesSelected = selectedBusinesses.length === businessOptions.length && businessOptions.length > 0;
    const allFarmsSelected = availableFarmsForSelectedBusinesses.length > 0
      ? selected.length === availableFarmsForSelectedBusinesses.length
      : false;
    setDisplayAllField(allBusinessesSelected && allFarmsSelected);
    
    filterFieldOnMapFromSelect(selectedBusinesses, selected, false);
    removeWells();
  };

  const filterFieldOnMapFromSelect = (selectedBusinessesArray, selectedFarmsArray, sharedFields) => {
    const safeBusinesses = selectedBusinessesArray ?? [];
    const safeFarms = selectedFarmsArray ?? [];
    let fields = userRegisteredFields.data?.fields?.concat(userSharedFields) || [];
    let selectedBusinessNames = safeBusinesses.map(business => business.value);
    let selectedFarmNames = safeFarms.map(farm => farm.value);
    let irrig_unit_ids = [];
    let geometries = [];

    if (fields && fields.length > 0) {
      for (let m = 0; m < fields.length; m++) {
        if (
          selectedBusinessNames.includes(fields[m].business_name?.trim()) &&
          selectedFarmNames.includes(fields[m].farm_name?.trim())
        ) {
          irrig_unit_ids.push(fields[m].irrig_unit_id);
          geometries.push({
            geometry: fields[m].geometry,
          });
        }
      }
    }
    filterFieldsOnMap(irrig_unit_ids, geometries, sharedFields);
  };


  const loadBusinessAndFarms = () => {
    let parser = new DOMParser();
    let businessList = BusinessValue;
    let farms = FarmsValue;
    let businessOptionsArray = [];
    let farmOptionsArray = [];

    for (let i = 0; i < businessList.length; i++) {
      const businessNameDoc = parser.parseFromString(
        businessList[i],
        "text/html"
      );
      for (let j = 0; j < farms.length; j++) {
        const businessName = parser.parseFromString(
          farms[j].businessName,
          "text/html"
        );
        if (businessNameDoc.body.innerText === businessName.body.innerText) {
          const farmNameDoc = parser.parseFromString(
            farms[j].farmName,
            "text/html"
          );
          const farmName = farmNameDoc.body.innerText;
          farmOptionsArray.push({
            value: farmName,
            label: farmName,
            businessName: businessNameDoc.body.innerText,
          });
        }
      }

      const businessName = businessNameDoc.body.innerText;
      businessOptionsArray.push({
        value: businessName,
        label: businessName,
      });
    }
    setBusinessOptions(businessOptionsArray);
    setFarmOptions(farmOptionsArray);
    
    if (displayAllField) {
      setSelectedBusinesses(businessOptionsArray);
      setSelectedFarms(farmOptionsArray);
    }
  };

  const expandAll = () => {
    expandAllProp();
  };

  const collapseAll = () => {
    collapseAllProp();
    setTimeout(() => {
      let cards = document.getElementsByClassName("field_card");
      for (let i = 0; i < cards.length; i++) {
        cards[i].classList.remove("show");
      }
    }, 0);
  };
  const removeWells = () => {
    removeWellsProp();
  };

  const handleShareFields = async () => {
    await SessionHelper.handleRefreshToken();
    setShareFieldPopUp(true);
  };

  const handleFieldCheck = (
    selectedFieldData,
    shareFieldIrrigUnitId,
    shareUserFieldId,
    shareFieldName,
    shareFieldAcres,
    acresCurrentYear,
    shareFieldFarm,
    shareFieldBusiness,
    fieldSharedByUser,
    shareFieldEditor,
    is_primary_editing,
    secondary_user_id,
    user_email
  ) => {
    let selectedIrrigUnitIdsValue = selectedIrrigUnitIds;
    let selectedFields = selectedFieldsOnPanel;
    if (
      selectedFields.some(
        (field) => field.irrig_unit_id === shareFieldIrrigUnitId
      )
    ) {
      selectedFields = selectedFields.filter((field) => {
        return field.irrig_unit_id !== shareFieldIrrigUnitId;
      });
    } else {
      selectedFields.push({
        fieldData: selectedFieldData,
        irrig_unit_id: shareFieldIrrigUnitId,
        fieldId: shareUserFieldId,
        fieldName: shareFieldName,
        fieldAcres: shareFieldAcres,
        acresCurrentYear: acresCurrentYear,
        fieldFarm: shareFieldFarm,
        fieldBusiness: shareFieldBusiness,
        fieldSharedByOtherUser: fieldSharedByUser,
        shareFieldEditor: shareFieldEditor,
        is_primary_editing: is_primary_editing,
        secondary_user_id: secondary_user_id,
        user_email: user_email,
      });
    }
    if (
      selectedIrrigUnitIdsValue.some(
        (irrig_unit_id) => irrig_unit_id === shareFieldIrrigUnitId
      )
    ) {
      selectedIrrigUnitIdsValue = selectedIrrigUnitIdsValue.filter(
        (field_irrig_unit_id) => {
          return field_irrig_unit_id !== shareFieldIrrigUnitId;
        }
      );
    } else {
      selectedIrrigUnitIdsValue.push(shareFieldIrrigUnitId);
    }
    setSelectedFieldsOnPanel(selectedFields);
    setSelectedIrrigUnitIds(selectedIrrigUnitIdsValue);
    field_check(selectedFields, true);
  };
  const handleCloseShareModal = () => {
    setShareFieldPopUp(false);
  };

  const handleClearAllSelectedFields = () => {
    setSelectedFieldsOnPanel([]);
    setSelectedIrrigUnitIds([]);
    setSelectAll(false);
  };

  const handleRejectOrDeleteShareFieldClick = (
    e,
    shareFieldId,
    selectedField
  ) => {
    setShowConfirmPopup(true);
    setHeader(DELETE_OR_REJECT_ACCESS_TO_SHARE_FIELD);
    setSelectedField(selectedField);
    setShareFieldId(shareFieldId);
  };

  const closeWarningPopup = () => {
    setShowConfirmPopup(false);
    setHeader(EMPTY);
    setShareFieldId(EMPTY);
  };

  const performWarningAction = async (e, idx) => {
    let id = shareFieldId;
    const user_email = loggedInUser;
    let payload = {};
    if (idx === 0) {
      payload = {
        shared_field_id: id,
        deleted: true,
      };
    } else if (idx === 1) {
      payload = {
        shared_field_id: id,
        rejected: true,
      };
    }

    try {
      await ShareFieldService.updateShareFieldDetails(payload);
      setShowConfirmPopup(false);
      setHeader(EMPTY);
      setAlertMessage(
        idx === 0
          ? SHARED_FIELD_DELETED_SUCCESSFULLY
          : SHARED_FIELD_REJECTED_SUCCESSFULLY
      );
      setVariant(INFO);
      setSubmitError(true);
      setShareFieldId(EMPTY);
      setOverlayLoading(true);

      await refreshPanel(true);
      const myDiv = document.getElementsByClassName(
        "farmer-panel-fields-accordion"
      );
      myDiv[0].scrollTop = 0;
      setOverlayLoading(false);
    } catch (error) {
      console.error(ERROR_WHILE_UPDATING_FIELD, error);
      handleCatchErrorLogs(
        error.response.data.message,
        "RejectField_performWarningAction",
        payload,
        error,
        user_email,
        error.response.status === StatusCodes.BAD_REQUEST ? false : true
      );
    }
  };

  const handleCatchErrorLogs = (
    errormessage,
    actionMethod,
    payload,
    e,
    user_email,
    sendFluentd
  ) => {
    setShowConfirmPopup(false);
    setHeader(EMPTY);
    setAlertMessage(errormessage);
    setVariant(DANGER);
    setSubmitError(true);
    setShareFieldId(EMPTY);

    if (sendFluentd === true) {
      FluentdHelper.logEvent(
        errormessage,
        actionMethod,
        user_email,
        {
          request: payload,
          response: e,
        },
        LOGERROR
      );
    }
  };

  const getValidatedYears = (sharedField) => {
    let seasonAllowed = [];
    if (sharedField) {
      let currentyear = new Date().getFullYear();
      let rowData = sharedField;
      let addedDate = new Date(rowData.added_on);
      let addedYear = addedDate.getFullYear();
      let removedOn = rowData.removed;
      let seasonChangeDate = new Date(`15/APR/${addedYear}`).getTime();
      let year = 0;
      let removedYear =
        removedOn !== null ? new Date(rowData.removed).getFullYear() : null;
      if (addedYear === removedYear && removedYear !== null) {
        year = addedYear;
        seasonAllowed.push(year.toString());
      } else if (addedYear !== removedYear && removedYear !== null) {
        for (let j = addedYear; j < removedYear; j++) {
          year = j;
          seasonAllowed.push(year.toString());
          year += 1;
          if (year === removedYear) {
            seasonChangeDate = new Date(`15/APR/${year}`).getTime();
            if (removedOn > seasonChangeDate) {
              seasonAllowed.push(year.toString());
            }
          }
        }
      } else if (removedYear === null) {
        for (let j = addedYear; j <= currentyear; j++) {
          year = j;
          seasonAllowed.push(year.toString());
        }
      }
    }
    return seasonAllowed;
  };

  const handleSelectAll = (status) => {
    setSelectAll(status);
    setSelectedFieldsOnPanel([]);
    setSelectedIrrigUnitIds([]);
    if (status) {
      let userRegisteredFieldsValue = userRegisteredFields;
      let userSharedFieldsValue = userSharedFields;

      let selectedFields = [];
      let selectedIrrigUnitIdsValue = [];
      let validUserSharedField = _.filter(userSharedFieldsValue, {
        rejected: false,
      });
      
      const selectedBusinessNames = selectedBusinesses.map(business => business.value.trim());
      const selectedFarmNames = selectedFarms.map(farm => farm.value.trim());

      if (
        (userRegisteredFieldsValue &&
          Object.keys(userRegisteredFieldsValue).length > 0) ||
        (validUserSharedField && Object.keys(validUserSharedField).length > 0)
      ) {
        const allFields =
          userRegisteredFieldsValue.data.fields.concat(validUserSharedField);
        for (let i = 0; i < allFields.length; i++) {
          if (
            selectedBusinessNames.includes(allFields[i].business_name.trim()) &&
            selectedFarmNames.includes(allFields[i].farm_name.trim())
          ) {
            let is_primary_editing = true;
            let secondary_user_id = "N/A";
            let fieldSharedByOtherUser = false;
            let shareFieldEditor = 0;
            let fieldAcres = null;
            let user_email = loggedInUser;
            if (allFields[i].primary_user_id) {
              fieldSharedByOtherUser = true;
              shareFieldEditor = allFields[i].editor;
              secondary_user_id = allFields[i].secondary_user_id;
              is_primary_editing = false;
              user_email = allFields[i].primary_user_email;
            }
            if (allFields[i].hasOwnProperty("primary_user_id")) {
              fieldAcres = allFields[i].irrig_unit_acres;
            } else {
              fieldAcres = allFields[i].acres;
            }
            let acresCurrentYear = getCurrentYearAcres(
              allFields[i].irrig_unit_id
            );
            let currentYearAcres = EMPTY;
            if (acresCurrentYear === false) {
              currentYearAcres = fieldAcres;
            } else {
              currentYearAcres = acresCurrentYear;
            }
            selectedFields.push({
              irrig_unit_id: allFields[i].irrig_unit_id,
              fieldId: allFields[i].user_field_id
                ? allFields[i].user_field_id
                : allFields[i].field_id,
              fieldName: allFields[i].field_name,
              fieldAcres: fieldAcres,
              acresCurrentYear: currentYearAcres,
              fieldFarm: allFields[i].farm_name,
              fieldBusiness: allFields[i].business_name,
              is_primary_editing: is_primary_editing,
              secondary_user_id: secondary_user_id,
              shareFieldEditor: shareFieldEditor,
              fieldSharedByOtherUser: fieldSharedByOtherUser,
              user_email: user_email,
            });

            selectedIrrigUnitIdsValue.push(allFields[i].irrig_unit_id);

            setSelectedFieldsOnPanel(selectedFields);
            setSelectedIrrigUnitIds(selectedIrrigUnitIdsValue);
          }
        }
      }
    } else {
      removeWells();
    }
  };

  const closeAlert = () => {
    setAlertMessage(EMPTY);
    setVariant(EMPTY);
    setSubmitError(false);
  };

  const getGeometry = (usersFields) => {
    if (AllPolygons.hasOwnProperty("features")) {
      let geometry = _.find(AllPolygons.features, (field) => {
        return field.properties.irrig_unit_id === usersFields.irrig_unit_id;
      });
      return geometry;
    } else {
      return null;
    }
  };

  const AddFilteredFields = (allFields, selectedFarms, selectedBusinesses) => {
    const filteredUserFields = [];
    for (let i = 0; i < allFields.length; i++) {
      if (
        selectedBusinesses.includes(allFields[i].business_name.trim()) &&
        selectedFarms.includes(allFields[i].farm_name.trim())
      ) {
        filteredUserFields.push(allFields[i]);
      }
    }
    return filteredUserFields;
  };

  const userRegisteredField = [];
  let userFieldCrops = [];

  const getFilteredFarmOptions = () => {
    if (selectedBusinesses.length === 0) {
      return [];
    }
    const selectedBusinessNames = selectedBusinesses.map(business => business.value);
    return farmOptions.filter(farm => 
      selectedBusinessNames.includes(farm.businessName)
    );
  };

  const filteredFarmOptions = getFilteredFarmOptions();

  const renderBusiness = (
    <div>
      <div key="chkAllFieldsDiv" className="mb-1">
        <Form.Check
          key="chkAllFields"
          type="checkbox"
          name="chkDisplayAllFields"
          label="Display all fields"
          id="chkAllFields"
          checked={displayAllField}
          onChange={handleDisplayAllField}
        />
      </div>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold">Business</Form.Label>
        <Select
          isMulti
          name="business"
          options={businessOptions}
          value={selectedBusinesses}
          className="basic-multi-select"
          onChange={handleBusinessChange}
          placeholder="Select Business"
          styles={FARM_BUSINESS_SELECT_STYLES}
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold">Farm</Form.Label>
        <Select
          isMulti
          name="farm"
          options={filteredFarmOptions}
          value={selectedFarms}
          className="basic-multi-select"
          onChange={handleFarmChange}
          placeholder="Select Farm"
          isDisabled={selectedBusinesses.length === 0}
          styles={FARM_BUSINESS_SELECT_STYLES}
        />
      </Form.Group>
    </div>
  );
  
  const selectedBusinessNames = selectedBusinesses.map(business => business.value.trim());
  const selectedFarmNames = selectedFarms.map(farm => farm.value.trim());

  const shouldShowEmptyMessage = !displayAllField && (selectedBusinesses.length === 0 || selectedFarms.length === 0);

  if (
    (userRegisteredFields && Object.keys(userRegisteredFields).length > 0) ||
    userSharedFields.length > 0
  ) {
    const allFields = userRegisteredFields.data.fields.concat(userSharedFields);
    const filteredUserFields = AddFilteredFields(
      allFields,
      selectedFarmNames,
      selectedBusinessNames
    );

    userFieldCrops = UserCropDetails;
    const sortedUsersFields = filteredUserFields.sort(function (a, b) {
      if (a.field_name.toLowerCase() < b.field_name.toLowerCase()) {
        return -1;
      }
      if (a.field_name.toLowerCase() > b.field_name.toLowerCase()) {
        return 1;
      }
      return 0;
    });
    let fieldNames = sortedUsersFields.map((field) => {
      let irrig_unit_id = field.irrig_unit_id;
      let isShared = false;
      if (field.hasOwnProperty("primary_user_id")) {
        isShared = true;
      }
      return {
        fieldName: field.field_name.trim().toLowerCase(),
        irrig_unit_id: irrig_unit_id,
        isShared: isShared,
      };
    });
    for (let j = 0; j < sortedUsersFields.length; j++) {
      const isSharedField = sortedUsersFields[j].hasOwnProperty(
        "primary_user_id"
      )
        ? true
        : false;
      if (
        isSharedField === true &&
        sortedUsersFields[j].hasOwnProperty("rejected") &&
        sortedUsersFields[j].rejected === true
      ) {
        continue;
      }
      const sortedUsersField = sortedUsersFields[j];

      const sharedField = isSharedField ? true : false;
      const shareFieldDetails = isSharedField
        ? {
            field_name: sortedUsersFields[j].field_name,
            business_name: sortedUsersFields[j].business_name,
            farm_name: sortedUsersFields[j].farm_name,
            acres: sortedUsersFields[j].irrig_unit_acres,
            owner_name: `${sortedUsersFields[j].primary_user}`,
            owner_field_name: `${sortedUsersFields[j].primary_field_name}`,
            owner_field_irrig_unit_id: sortedUsersFields[j].irrig_unit_id,
            shared_field_id: sortedUsersFields[j].shared_field_id,
            owner_user_email: `${sortedUsersFields[j].primary_user_email}`,
            secondary_user_id: `${sortedUsersFields[j].secondary_user_id}`,
          }
        : {};

      const sharedFieldInfo = sortedUsersFields[j];
      const validatedYears = isSharedField
        ? getValidatedYears(sharedFieldInfo)
        : [];
      const fieldId = sortedUsersFields[j].user_field_id
        ? sortedUsersFields[j].user_field_id
        : sortedUsersFields[j].field_id;
      const shareFieldId = sortedUsersFields[j].shared_field_id;

      const cropDetails = isSharedField
        ? userFieldCrops.filter(
            (c) =>
              c.user_field_id === fieldId &&
              validatedYears.includes(c.year.toString())
          )
        : userFieldCrops.filter((c) => c.user_field_id === fieldId);

      const irrig_unit_ID = sortedUsersFields[j].irrig_unit_id;
      const selectedField = sortedUsersFields[j].field_name;

      const acres = isSharedField
        ? parseFloat(sortedUsersFields[j].irrig_unit_acres).toFixed(2)
        : parseFloat(sortedUsersFields[j].acres).toFixed(2);
      let crops = [];
      let acresCurrentYear = getCurrentYearAcres(irrig_unit_ID);
      let currentYearAcres = EMPTY;
      if (acresCurrentYear === false) {
        currentYearAcres = acres;
      } else {
        currentYearAcres = acresCurrentYear;
      }
      let is_primary_editing = true;
      let secondary_user_id = "N/A";
      let fieldSharedByOtherUser = false;
      let shareFieldEditor = false;

      let user_email = loggedInUser;
      if (isSharedField) {
        fieldSharedByOtherUser = true;
        shareFieldEditor = sortedUsersFields[j].editor;
        is_primary_editing = false;
        secondary_user_id = sortedUsersFields[j].secondary_user_id;
        user_email = sortedUsersFields[j].primary_user_email;
      }
      const sortedcrops = cropDetails.sort((a, b) => {
        if (a.year < b.year) {
          return -1;
        }
        if (a.year > b.year) {
          return 1;
        }
        if (a.crop.toLowerCase() < b.crop.toLowerCase()) {
          return -1;
        }
        if (a.crop.toLowerCase() > b.crop.toLowerCase()) {
          return 1;
        }

        return 0;
      });
      if (sortedcrops.length === 0) {
        crops.push(
          <li key={"crop0000"}>
            <i>{"No crop added"}</i>
          </li>
        );
      }
      for (let n = 0; n < sortedcrops.length; n++) {
        crops.push(
          <li key={"crop" + n}>
            {`${sortedcrops[n].crop} | ${sortedcrops[n].tillage} (${Number(
              sortedcrops[n].acres
            ).toFixed(2)}) - ${sortedcrops[n].year}`}
          </li>
        );
      }

      const coordinates = sortedUsersFields[j];
      const fillColor1 = isSharedField ? SHAREDFIELD : ADDED;
      const fillColor2 = SELECTED;
      const farmName = sortedUsersFields[j].farm_name;
      const businessName = sortedUsersFields[j].business_name;
      let geomObject = getGeometry(coordinates);
      if (geomObject) {
        coordinates.geometry = geomObject.geometry;
      }
      const paths = GoogleMapHelper.getCoordinates(coordinates);
      const coords = GoogleMapHelper.getPolygonCenter(coordinates);
      userRegisteredField.push(
        <div
          key={`field-${irrig_unit_ID}`}
          className="d-flex align-items-start"
        >
          <Form.Check
            key={"chkFieldId" + selectedField}
            id={"chkFieldId" + selectedField}
            onChange={(e) => {
              showFieldOnMAP(
                coords,
                paths,
                irrig_unit_ID,
                fillColor1,
                fillColor2
              );
              handleFieldCheck(
                sortedUsersField,
                irrig_unit_ID,
                fieldId,
                selectedField,
                acres,
                currentYearAcres,
                farmName,
                businessName,
                fieldSharedByOtherUser,
                shareFieldEditor,
                is_primary_editing,
                secondary_user_id,
                user_email
              );
            }}
            checked={selectedIrrigUnitIds.some(
              (irrig_unit_id) => irrig_unit_id === irrig_unit_ID
            )}
          />

          <Accordion.Item
            eventKey={j}
            key={j}
            id={"card_" + irrig_unit_ID}
            className="flex-grow-1 transition-bg"
          >
            <Accordion.Header onClick={collapseAll}>
              <a
                className={`wdp-field-name cursor-pointer ${
                  isSharedField ? "highlight-share-field" : "highlight-field"
                }`}
              >
                {selectedField}
              </a>
            </Accordion.Header>
            <Accordion.Collapse
              eventKey={j}
              id={irrig_unit_ID}
              className={`field_card  ${
                (!fieldClicked && expand) ||
                (fieldClicked && selectedFieldProp === irrig_unit_ID)
                  ? "show"
                  : "collapse"
              }`}
            >
              <>
                <div className="farmer-panel-fields-icons">
                  <span
                    onClick={(e) => {
                      handdlePanelButtonClick(
                        sortedUsersField,
                        fieldId,
                        cropDetails,
                        acres,
                        irrig_unit_ID,
                        selectedField,
                        sortedUsersField,
                        fieldNames,
                        sharedField,
                        shareFieldDetails,
                        "fieldDetails"
                      );
                    }}
                  >
                    <i className="fa-regular fa-pen-to-square" />
                  </span>
                  <span
                    onClick={(e) => {
                      handdlePanelButtonClick(
                        sortedUsersField,
                        fieldId,
                        cropDetails,
                        acres,
                        irrig_unit_ID,
                        selectedField,
                        sortedUsersField,
                        fieldNames,
                        sharedField,
                        shareFieldDetails,
                        "summary"
                      );
                    }}
                  >
                    <i className="fa-regular fa-eye" />
                  </span>
                  {isSharedField ? (
                    <span
                      onClick={(e) => {
                        handleRejectOrDeleteShareFieldClick(
                          e,
                          shareFieldId,
                          selectedField
                        );
                      }}
                    >
                      <i className="fa-regular fa-trash-can" />
                    </span>
                  ) : (
                    EMPTY
                  )}
                </div>
                <ul>
                  <li>
                    <span className="fw-bold ">Certified Acres:</span> {acres}
                  </li>
                  <li>
                    <span className="fw-bold ">Farm:</span> {farmName}
                  </li>
                  <li>
                    <span className="fw-bold ">Business:</span> {businessName}
                  </li>
                  <li>
                    <span className="fw-bold ">Crops:</span> <ul>{crops}</ul>
                  </li>
                </ul>
              </>
            </Accordion.Collapse>
          </Accordion.Item>
        </div>
      );
    }
  }

  return (
    <aside
      ref={panelRef}
      className={`sidebar farmer-panel ${
        !showWdpPanel && "hide-sidebar"
      }`}
    >
      <LoadingOverlay
        showSpinner={true}
        active={overlayLoading}
        text="Loading Map..."
      />
      <div className="farmer-panel-filter">
        <div
          className="hide-panel"
          onClick={() => setShowWdpPanel(!showWdpPanel)}
        >
          <b className="close">{showWdpPanel ? ">" : "<"}</b>
        </div>
        <div className="display-options-panel">
          <div className="display-options-header">
            <span className="display-options-title">Display Options</span>
            <a
              href="#"
              className="manage-farms-business-link"
              onClick={(e) => {
                e.preventDefault();
                setShowManageFarmBusinessModal(true);
              }}
            >
              {MANAGE_FARM_BUSINESS}
              <i className="fa fa-cog ms-1" />
            </a>
          </div>
          <div className="display-option-body">
            {renderBusiness}
          </div>
        </div>
      </div>
      {shouldShowEmptyMessage ? (
        <div className="empty-fields-message mt-3">
          <div className="empty-fields-message-text">
            {SELECT_BUSINESS_AND_FARM_TO_VIEW_FIELDS}
          </div>
        </div>
      ) : (
        <>
          <Card className="farmer-panel-fields-card">
            <Card.Header>
              {`Field Details - Selected fields (${selectedFieldsOnPanel.length}) `}
            </Card.Header>
          </Card>
          {userRegisteredField?.length === 0 ? (
            <div className="empty-fields-message mt-3">
              <div className="empty-fields-message-text">
                {NO_FIELDS_FOR_SELECTED_FILTER}
              </div>
            </div>
          ) : (
            <>
              <div className="text-end mb-2">
                {selectAll === true && (
                  <a
                    onClick={() => handleSelectAll(false)}
                    className="btn btn-secondary"
                    title="Deselect All Fields"
                  >
                    <i className="fa-regular fa-square-check" />
                  </a>
                )}
                {selectAll === false && (
                  <a
                    onClick={() => handleSelectAll(true)}
                    className="btn btn-secondary"
                    title="Select All Fields"
                  >
                    <i className="fa-regular fa-square" />
                  </a>
                )}
                <a
                  onClick={expandAll}
                  className="btn btn-secondary"
                  title="Show All Field Details"
                >
                  <i className="fa fa-expand"></i>
                </a>
                <a
                  onClick={collapseAll}
                  className="btn btn-secondary"
                  title="Hide All Field Details"
                >
                  <i className="fa fa-compress"></i>
                </a>
                <a
                  onClick={handleShareFields}
                  className="btn btn-secondary"
                  title="Share Field(s)"
                >
                  <i className="fa-solid fa-share-nodes"></i>
                </a>
              </div>
              <div className="farmer-panel-fields">
                <Accordion className="mt-2 farmer-panel-fields-accordion">
                  {submitError ? (
                    <Alert
                      key="messageAlert"
                      variant={variant}
                      closeAlert={(e) => closeAlert(e)}
                      alertMessage={alertMessage}
                      dismissible
                    />
                  ) : (
                    EMPTY
                  )}
                  {userRegisteredField}
                </Accordion>
                {showFieldPopup ? (
                  <FieldDetailsModal
                    acres={fieldAcres}
                    cropDetails={fieldCrops}
                    closeModal={(e) => closeModal(e)}
                    fieldId={fieldId}
                    irrig_unit_Id={irrig_unit_Id}
                    refreshPanel={(refreshPanelValue) =>
                      refreshPanel(refreshPanelValue)
                    }
                    selectedField={selectedField}
                    fieldDetails={fieldDetails}
                    fieldNames={fieldNames}
                    userClaimedFields={userClaimedFields}
                    sharedField={sharedField}
                    shareFieldDetails={shareFieldDetails}
                    userSharedFields={userSharedFields}
                    yearAcresDetails={yearAcresDetailsProp}
                    defaultModalActiveKey={defaultModalActiveKey}
                    applyDisplayAllFieldsAndFilter={applyDisplayAllFieldsAndFilter}
                  />
                ) : (
                  EMPTY
                )}
                {shareFieldPopUp ? (
                  <ShareFieldPopUp
                    selectedFieldsOnPanel={selectedFieldsOnPanel}
                    closeModal={(e) => handleCloseShareModal(e)}
                    clearAllSelectedFields={(e) => handleClearAllSelectedFields(e)}
                  ></ShareFieldPopUp>
                ) : (
                  EMPTY
                )}
                {showConfirmPopup && (
                  <DeletePopUp
                    showConfirmPopup={showConfirmPopup}
                    selectedField={selectedFieldProp}
                    index={0}
                    closeWarningPopup={(e) => closeWarningPopup(e)}
                    performWarningAction={(e, idx) => performWarningAction(e, idx)}
                    header={header}
                  />
                )}
              </div>
            </>
          )}
        </>
      )}
      {showManageFarmBusinessModal && (
        <ManageFarmBusinessModal
          closeModal={() => setShowManageFarmBusinessModal(false)}
          onFarmBusinessUpdated={onFarmBusinessUpdated}
        />
      )}
    </aside>
  );
}

export default WDPPanel;
